import { render, staticRenderFns } from "./InfoSysAndWeb.vue?vue&type=template&id=2a9edfb4&scoped=true&"
import script from "./InfoSysAndWeb.vue?vue&type=script&lang=js&"
export * from "./InfoSysAndWeb.vue?vue&type=script&lang=js&"
import style0 from "./InfoSysAndWeb.vue?vue&type=style&index=0&id=2a9edfb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9edfb4",
  null
  
)

export default component.exports